/**
 * This file was auto-generated by Fern from our API Definition.
 */

import { ApiKeys } from './api/resources/apiKeys/client/Client';
import { Credentials } from './api/resources/credentials/client/Client';
import { Desk } from './api/resources/desk/client/Client';
import { DidcommMessages } from './api/resources/didcommMessages/client/Client';
import { Dids } from './api/resources/dids/client/Client';
import { Drafts } from './api/resources/drafts/client/Client';
import { Files } from './api/resources/files/client/Client';
import { Gdpr } from './api/resources/gdpr/client/Client';
import { Keys } from './api/resources/keys/client/Client';
import { Presentations } from './api/resources/presentations/client/Client';
import { PublishedSchemas } from './api/resources/publishedSchemas/client/Client';
import { Schemas } from './api/resources/schemas/client/Client';
import * as core from './core';
import { mergeHeaders } from './core/headers';
import * as environments from './environments';

export declare namespace TruvityClient {
    export interface Options {
        environment?: core.Supplier<environments.TruvityEnvironment | string>;
        /** Specify a custom URL to connect the client to. */
        baseUrl?: core.Supplier<string>;
        apiKey?: core.Supplier<string | undefined>;
        /** Additional headers to include in requests. */
        headers?: Record<string, string | core.Supplier<string | undefined> | undefined>;
        fetcher?: core.FetchFunction;
    }

    export interface RequestOptions {
        /** The maximum time to wait for a response in seconds. */
        timeoutInSeconds?: number;
        /** The number of times to retry the request. Defaults to 2. */
        maxRetries?: number;
        /** A hook to abort the request. */
        abortSignal?: AbortSignal;
        /** Additional query string parameters to include in the request. */
        queryParams?: Record<string, unknown>;
        /** Additional headers to include in the request. */
        headers?: Record<string, string | core.Supplier<string | undefined> | undefined>;
    }
}

export class TruvityClient {
    protected readonly _options: TruvityClient.Options;
    protected _apiKeys: ApiKeys | undefined;
    protected _credentials: Credentials | undefined;
    protected _didcommMessages: DidcommMessages | undefined;
    protected _dids: Dids | undefined;
    protected _drafts: Drafts | undefined;
    protected _files: Files | undefined;
    protected _keys: Keys | undefined;
    protected _presentations: Presentations | undefined;
    protected _publishedSchemas: PublishedSchemas | undefined;
    protected _schemas: Schemas | undefined;
    protected _gdpr: Gdpr | undefined;
    protected _desk: Desk | undefined;

    constructor(_options: TruvityClient.Options = {}) {
        this._options = {
            ..._options,
            headers: mergeHeaders(
                {
                    'X-Fern-Language': 'JavaScript',
                    'X-Fern-SDK-Name': '@truvity/sdk',
                    'X-Fern-SDK-Version': '0.40.14',
                    'X-Truvity-OAS-Version': '0.40.12-devel+a26921cf75bc',
                    'User-Agent': '@truvity/sdk/0.40.14',
                    'X-Fern-Runtime': core.RUNTIME.type,
                    'X-Fern-Runtime-Version': core.RUNTIME.version,
                },
                _options?.headers,
            ),
        };
    }

    public get apiKeys(): ApiKeys {
        return (this._apiKeys ??= new ApiKeys(this._options));
    }

    public get credentials(): Credentials {
        return (this._credentials ??= new Credentials(this._options));
    }

    public get didcommMessages(): DidcommMessages {
        return (this._didcommMessages ??= new DidcommMessages(this._options));
    }

    public get dids(): Dids {
        return (this._dids ??= new Dids(this._options));
    }

    public get drafts(): Drafts {
        return (this._drafts ??= new Drafts(this._options));
    }

    public get files(): Files {
        return (this._files ??= new Files(this._options));
    }

    public get keys(): Keys {
        return (this._keys ??= new Keys(this._options));
    }

    public get presentations(): Presentations {
        return (this._presentations ??= new Presentations(this._options));
    }

    public get publishedSchemas(): PublishedSchemas {
        return (this._publishedSchemas ??= new PublishedSchemas(this._options));
    }

    public get schemas(): Schemas {
        return (this._schemas ??= new Schemas(this._options));
    }

    public get gdpr(): Gdpr {
        return (this._gdpr ??= new Gdpr(this._options));
    }

    public get desk(): Desk {
        return (this._desk ??= new Desk(this._options));
    }
}
